"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";

export default function RecuperarSenhaPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(
          Array.isArray(data.message)
            ? data.message.join(", ")
            : data.message || "Não foi possível solicitar a recuperação.",
        );
        return;
      }

      setSuccessMessage(
        "Se o e-mail estiver cadastrado, enviaremos as instruções para redefinição de senha. Caso não encontre a mensagem, verifique também as pastas de spam ou lixo eletrônico.",
      );

      setEmail("");
    } catch {
      setErrorMessage("Erro de conexão com a API.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      {successMessage ? (
        <div className="flex min-h-[520px] items-center justify-center">
          <div className="w-full max-w-2xl text-center">
            <div className="platform-text-muted text-sm">Recuperação solicitada</div>

            <h1 className="platform-text mt-3 text-4xl font-semibold tracking-tight">
              Instruções enviadas
            </h1>

            <p className="platform-text-secondary mt-4 text-base leading-7">
              Se o e-mail estiver cadastrado, enviaremos as instruções para redefinição de senha.
              Caso não encontre a mensagem na caixa de entrada, verifique também as pastas de spam ou lixo eletrônico.
            </p>

            <div className="mt-8 flex justify-center">
              <Link
                href="https://trinitmusic.com.br"
                className="platform-button-primary inline-flex px-6 py-2 text-sm"
              >
                Voltar para o site
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="mb-8">
            <div className="platform-text-muted text-sm">Recuperação de acesso</div>

            <h1 className="platform-text mt-3 text-4xl font-semibold tracking-tight">
              Recuperar senha
            </h1>

            <p className="platform-text-secondary mt-4 text-base leading-7">
              Informe seu e-mail para receber as instruções de redefinição de senha.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="platform-text-secondary mb-2 block text-sm font-medium">
                E-mail
              </label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@exemplo.com"
                className="platform-input"
              />
            </div>

            {errorMessage ? (
              <div className="platform-alert-error">{errorMessage}</div>
            ) : null}

            <button
              type="submit"
              disabled={loading}
              className="platform-button-primary"
            >
              {loading ? "Enviando..." : "Enviar instruções"}
            </button>
          </form>

          <div className="platform-divider platform-text-secondary mt-8 pt-6 text-sm">
            Lembrou sua senha?{" "}
            <Link href="/login" className="platform-text transition">
              Voltar para login
            </Link>
          </div>
        </>
      )}
    </div>
  );
}